var map = {
	"./Appreciating.mp3": 765,
	"./CreateUniqueRelaxingPlace.mp3": 126,
	"./FightingCancer.mp3": 632,
	"./ForYourSurgery.mp3": 843,
	"./FunInteractiveAndSoothing.mp3": 705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 285;